'use strict';

var closeIcon =
  '<svg version="1.1" class="alert-close" data-dismiss="alert" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="16" height="16" viewBox="0 0 320 320"><path d="M160 135.28l-129.957-129.957c-7.148-7.148-18.057-6.99-24.884-0.163-6.874 6.874-6.753 17.967 0.163 24.884l129.957 129.957-129.957 129.957c-7.148 7.148-6.99 18.057-0.163 24.884 6.874 6.874 17.967 6.753 24.884-0.163l129.957-129.958 129.957 129.958c7.148 7.148 18.057 6.99 24.884 0.163 6.874-6.874 6.753-17.967-0.163-24.884l-129.958-129.957 129.958-129.957c7.148-7.148 6.99-18.057 0.163-24.884-6.874-6.874-17.967-6.753-24.884 0.163l-129.957 129.957z"></path></svg>';

var AlertService = {
  open: function (options) {
    var defaults = {
      type: 'success',
      position: 'container',
      timeout: 5000
    };

    // TODO: Use vanilla
    var settings = $.extend({}, defaults, options);

    var $el = document.querySelector('.alert-' + settings.position);

    $el.innerHTML =
      '<div class="alert alert-' +
      settings.type +
      ' alert-dismissible"  dismiss-on-timeout="' +
      settings.timeout +
      '">' +
      this.getIcon(settings.type) +
      '<p class="alert-text" >' +
      settings.msg +
      '</p>' +
      closeIcon +
      '</div>';

    $el.querySelector('.alert-close').addEventListener('click', this.close.bind(null, $el), true);

    if (settings.timeout) {
      this.startTimeout($el, settings.timeout);
    }
  },

  getIcon: function (type) {
    var iconExclamation =
      'M16 1C7.7147273 1 1 7.7065971 1 15.9818379 1 24.2570788 7.7147273 31 16 31s15-6.7465438 15-14.9818379C31 7.7429212 24.2852727 1 16 1zm0 28.5475738c-7.46002934 0-13.5458131-6.078415-13.5458131-13.5294117C2.4541869 8.56716535 8.53997067 2.44880356 16 2.44880356c7.4600293 0 13.5458131 6.07841505 13.5458131 13.56935854 0 7.4909434-6.0857838 13.5294117-13.5458131 13.5294117zm.745253-7.4110499c0 .4321199-.3526534.7842974-.7852482.7842974-.4326437 0-.7852482-.3522265-.7852482-.7842974 0-.43212.3526535-.7842975.7852482-.7842975.4325948 0 .7852482.3522265.7852482.7842975zm-1.5305012-3.8453141V9.46768035c0-.39217318.3126583-.7044529.7053069-.7044529.3926486 0 .7053069.31227972.7053069.7044529v8.82352945c0 .3921731-.3126583.7044528-.7053069.7044528-.3926486.0435694-.7053069-.3122797-.7053069-.7044528z';
    var iconCheck =
      'M16 1C7.7147273 1 1 7.7065971 1 15.9818379 1 24.2570788 7.7147273 31 16 31s15-6.7465438 15-14.9818379C31 7.7429212 24.2852727 1 16 1zm0 28.5475738c-7.46002934 0-13.5458131-6.078415-13.5458131-13.5294117C2.4541869 8.56716535 8.53997067 2.44880356 16 2.44880356c7.4600293 0 13.5458131 6.07841505 13.5458131 13.56935854 0 7.4909434-6.0857838 13.5294117-13.5458131 13.5294117zm6.2595977-18.3810228l-7.7626693 8.5583466-4.67659276-3.6663779c-.21718705-.1707709-.53589642-.1356267-.70964606.0772182-.17425472.2138349-.1388987.5251825.07879344.6959534l5.05086168 3.9599059c.0929358.0727633.2045599.1084024.3156788.1084024.1394038 0 .2783025-.0564286.3778045-.166316l8.0813786-8.9097882c.1853666-.2039351.1666784-.5172627-.0419222-.6984284-.2091056-.18215564-.527815-.16384108-.7136867.041084z';
    var icon =
      '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" width="30" height="30" class="alert-icon"><g><path d="{{path}}" /></g></svg>';

    return icon.replace('{{path}}', /success/.test(type) ? iconCheck : iconExclamation);
  },

  close: function ($el) {
    var alert = $el.querySelector('.alert:first-child');
    if (alert) {
      alert.remove();
      clearTimeout(AlertService.closeTimeout);
      AlertService.closeTimeout = null;
    }
  },

  startTimeout: function ($el, timeout) {
    AlertService.closeTimeout = setTimeout(function () {
      AlertService.close($el);
    }, timeout);
  }
};

module.exports = AlertService;
